import { getTypes } from '@elab/components/connected/forms/DatepickerCalendar/redux';

export const storeName = 'loyalty-card-history';
export const DATE_FROM = 'dateFrom';
export const DATE_TO = 'dateTo';

const datepickerTypes = getTypes(storeName);

export default {
    ...datepickerTypes,
    SET_DATA_FIELD_VALUE: `${storeName}.SET_DATA_FIELD_VALUE`,
    SET_PAGE_SIZE: `${storeName}.SET_PAGE_SIZE`,
    UPDATE_LOYALTY_CARD_HISTORY_LIST: `${storeName}.UPDATE_LOYALTY_CARD_HISTORY_LIST`,
    SHOW_MORE: `${storeName}.SHOW_MORE`,
    RESET_RECORDS: `${storeName}.RESET_RECORDS`,
};
